import React, { useContext, useEffect } from 'react'
import { Container } from 'reactstrap'
import { withRouter } from 'react-router-dom'
import { GeneralContext } from '../../context/'
import HeroSlidesManager from './components/HeroSlidesManager'

const Index = () => {
    const { setBreadcrumb } = useContext(GeneralContext)
    useEffect(() => setBreadcrumb({ parent: 'Portada', parentLink: '/hero-slides', item: 'Hero' }), []) // eslint-disable-line
    return <div className="page-content"><Container fluid><h2>Hero de portada</h2><HeroSlidesManager /></Container></div>
}
export default withRouter(Index)
